import {LoggerService, LogLevel} from '../services/logger/logger.service';


/**
 * A logger to use inside other objects.
 *
 */
export class Logger {

  constructor(
    protected logger: LoggerService,
    protected componentName: string
  ) {
    this.logger.log(this.componentName, `New instance ${this.componentName} created`);
  }

  public setLogLevel(newLogLevel: LogLevel) {
    this.logger.setComponentLogLevel(this.componentName, newLogLevel);
  }

  public error(...data: any[]) {
    this.logger.error(this.componentName, ...data);
  }

  public warning(...data: any[]) {
    this.logger.warning(this.componentName, ...data);
  }

  public info(...data: any[]) {
    this.logger.info(this.componentName, ...data);
  }

  public log(...data: any[]) {
    this.logger.log(this.componentName, ...data);
  }

  public debug(...data: any[]) {
    this.logger.debug(this.componentName, ...data);
  }
}
